import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannelFlowResponseFilterSensitiveLog, } from "../models/models_0";
import { de_DescribeChannelFlowCommand, se_DescribeChannelFlowCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class DescribeChannelFlowCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "DescribeChannelFlow", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelFlowCommand")
    .f(void 0, DescribeChannelFlowResponseFilterSensitiveLog)
    .ser(se_DescribeChannelFlowCommand)
    .de(de_DescribeChannelFlowCommand)
    .build() {
}
